<template>
  <div>
    <ul class="docs" v-if="loadingStatus===true">
      <template v-for="item in items">
        <li v-if="item.lessonable">
            <div v-if="item.lessonable_type === 'file'" :key="item.id">
                <pdf-reader v-if="item.lessonable.file" :src="item.lessonable.file.path"></pdf-reader>
            </div>
            <div v-else-if="item.lessonable_type === 'html'" :key="item.id">
                 <div v-html="item.lessonable.layout"></div>
            </div>
            <div v-else-if="item.lessonable_type === 'video'" :key="item.id"> 
                      <iframe
                        :src="item.lessonable.link"
                        :title="item.lessonable.title" 
                        frameborder="0" 
                        height="300"
                        width="100%"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      >
                      </iframe>
            </div>
        </li>
      </template>
    </ul>
      <div v-else-if="loadingStatus===false"><h4 class="text-error">Установите в журнале плановый урок</h4></div>
  </div>
</template>

<script>
import { errorNotify } from "@/plugins/functions";

import { mapState } from "vuex";
export default {

  computed:{

  },
  data: () => ({
    cardLink: "",
    items: [],
    loadingStatus: null
  }),
  props: ["id"],
  async created() {
    this.cardLink = `business/timetables/${this.id}/resources`;
    this.$loading(true);
   this.items = await this.$http.get(this.cardLink).then(response => {
           this.loadingStatus = true;
      return response.data.data;
    }).catch(error => {
      this.loadingStatus = false;
        //  errorNotify(error, this.$notify);
    }).finally(() => {
        this.$loading(false);
    });
  },
  methods: {
 
  },
};
</script>

<style>
  .docs {
  max-width:1024px}
</style>
